'use strict';

import * as Onyx from '../../lib/onyx.min.js';

const DISABLED = false;
const MIN_LOAD_AUDIO_ERROR_COUNT = 3; // Number of times to try grabbing the audio before falling back to offline mode
const LOAD_AUDIO_TIMEOUT = 3000;
const RANDOMIZE_ORDER = true;
const MAX_ANSWERS = 2;
const TYPE = "SPLIT";
const USER_INPUT = false;

export default class ScenePedagogic extends Onyx.Scene {
    constructor(){
        super({
            template: '@@import routes/pedagogic/index.html'
        });

        this.wordAudio = [];
        this.wordAudioOffline = false;
    }

    stop(){

    }

    // onunload(){
    //     if(!document.getElementById("word-container")) return; // Occasionally with the word loading lag, we'll get overlapping timer events

    //     document.getElementById("word-container").style.opacity = 0;
    //     this.setTimeout(() => {
    //         document.getElementById("word-container").style.display = "none";
    //         document.getElementById("modal").style.display = "none";
    //     }, 1000);
    // }

    onload(){
        // TODO: This is a bit confusing. Should reconsider the render/route stack.
        this.visible = false; // This is so it doesn't clear on render
        this.clock = router.map.game.module.clock; // Sync with game clock
        this.clock.add(this);

        document.getElementById("modal").style.pointerEvents = (USER_INPUT)?"initial":"none";

        document.getElementById("modal").style.display = "initial";
        document.getElementById("word-container").style.display = "initial";
        document.getElementById("word-container").style.opacity = 1;
        document.getElementById("words-split").style.display = "none";
        document.getElementById("words-osr").style.display = "none";
        document.getElementById("words-s").style.display = "none";
        document.getElementById("loading").style.display = "";
        document.getElementById("word-osr-blank").innerHTML = "&nbsp;&nbsp;&nbsp;";

        this.questionAnswered = false;

        centralStation.randomQuestion(centralStation.player.id, centralStation.player.reading_stage, centralStation.questionSkill).then((data) => {
            if(DISABLED) return this.modalResult(true);

            this.currentWords = data.stimuli;
            this.currentQuestion = data.assessed;

            // Double check the result isn't blank
            if(!this.currentWords[0].text){
				throw new Error('Missing word');
            }
            
            // Reduce number of answers to MAX_ANSWERS
            while(this.currentWords.length > MAX_ANSWERS){
                // Find and remove an incorrect answer
                for(let i = 0; i < this.currentWords.length; i++){
                    if(!this.currentWords[i].isCorrect){
                        this.currentWords.splice(i, 1);
                        break;
                    }
                }
            }

            if(RANDOMIZE_ORDER) this.randomizeWords();

            document.getElementById("loading").style.display = "none";

            if(TYPE === "SPLIT"){
                document.getElementById("words-split").style.display = "";

                let wordElements = document.getElementsByClassName("word-wrapper");
                for(let element of wordElements){
                    element.style.display = "none";
                }

                for(let i = 0; i < this.currentWords.length; i++){
                    document.getElementById("word-"+i).innerHTML = this.currentWords[i].text;
                    document.getElementById("word-wrapper-"+i).style.display = "";
                }
            }else{
                // If Onset Rime
                if(this.currentQuestion.type == 'onset' || this.currentQuestion.type == 'rime'){
                    document.getElementById("words-osr").style.display = "";

                    // Build words
                    for(let i = 0; i < this.currentWords.length; i++){
                        let onset = this.currentWords[i].onsetAudio.replace(/\\/g, '/');
                        onset = onset.substring(onset.lastIndexOf('/')+1, onset.lastIndexOf('.'));

                        let rime = this.currentWords[i].rimeAudio.replace(/\\/g, '/');
                        rime = rime.substring(rime.lastIndexOf('/')+1, rime.lastIndexOf('.'));

                        this.currentWords[i].onset = onset;
                        this.currentWords[i].rime = rime;

                        document.getElementById("word-osr-onset").innerHTML = "";
                        document.getElementById("word-osr-rime").innerHTML = "";

                        if(this.currentQuestion.type == "rime"){
                            document.getElementById("word-osr-"+i).innerHTML = this.currentWords[i].rime;
                            document.getElementById("word-osr-onset").innerHTML = this.currentWords[i].onset;
                        }else{
                            document.getElementById("word-osr-"+i).innerHTML = this.currentWords[i].onset;
                            document.getElementById("word-osr-rime").innerHTML = this.currentWords[i].rime;
                        }

                        document.getElementById("word-osr-"+i).onclick = () => { this.emit("onanswerquestion", i) };
                    }    
                }else{
                    document.getElementById("words-s").style.display = "";

                    document.getElementById("word-s-0").innerHTML = this.currentWords[0].text;
                    document.getElementById("word-s-1").innerHTML = this.currentWords[1].text;
                    document.getElementById("word-s-2").innerHTML = this.currentWords[2].text;

                    document.getElementById("word-s-0").onclick = () => { this.emit("onanswerquestion", 0) };
                    document.getElementById("word-s-1").onclick = () => { this.emit("onanswerquestion", 1) };
                    document.getElementById("word-s-2").onclick = () => { this.emit("onanswerquestion", 2) };
                }
            }

            this.playCorrectWord();
        }).catch((err) => {
            throw Error(err.message);
        });
    }

    randomizeWords(){
        // Randomize words using the Fisher-Yates algorithm
        for (var i = this.currentWords.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = this.currentWords[i];
            this.currentWords[i] = this.currentWords[j];
            this.currentWords[j] = temp;
        }
    }

    getCorrectWordIndex() {
		for (var i = 0; i < this.currentWords.length; i++) {
			if (this.currentWords[i].isCorrect) {
				return i;
			}
		}
	}

    @Onyx.handles('click', {elementId: 'osr-listen'})
    @Onyx.handles('click', {elementId: 's-listen'})
    playCorrectWord(){
        let correctWordIndex = this.getCorrectWordIndex();
        this.playWordAudio(this.currentWords[correctWordIndex].text, this.currentWords[correctWordIndex].audio);
    }

    playWordAudio(word, wordUrl, callback, minTime = 0) {
		let startTime = new Date() * 1;
        
		if(centralStation.offline || this.wordAudioOffline || !wordUrl){
			this.speakWordAudio(word, wordUrl, callback, startTime, minTime);
		}else if(this.wordAudio[wordUrl]){
			this.wordAudio[wordUrl].play();

			this.setTimeout(() => {
				if(callback) callback();
			}, minTime);
		}else{
			this.wordAudio[wordUrl] = new Howl({
				src: [wordUrl],
                timeout: LOAD_AUDIO_TIMEOUT,
				onload: () => {
                    this.loadAudioErrorCount = 0;

					if(this.wordAudio[wordUrl]){
                        this.wordAudio[wordUrl].play();

                        this.setTimeout(() => {
                            if(callback) callback();
                        }, Math.max((startTime - new Date() * 1), minTime));
					}else{
                        this.speakWordAudio(word, wordUrl, callback, startTime, minTime);
                    }

				},
				onloaderror: () => {
                    this.loadAudioErrorCount += 1;
                    if(this.loadAudioErrorCount >= MIN_LOAD_AUDIO_ERROR_COUNT){
                        this.wordAudioOffline = true;
                    }
					this.speakWordAudio(word, wordUrl, callback, startTime, minTime);
				}
			});
		}
	}

    speakWordAudio(word, wordUrl, callback, startTime, minTime) {
        try {
            // var msg = new SpeechSynthesisUtterance(word);
            // window.speechSynthesis.speak(msg);
            centralStation.TTSSpeak(word);
        } catch (e) {
            console.error(e);
        } finally {
            this.setTimeout(() => {
					if(wordUrl && this.wordAudio[wordUrl]) {

						delete this.wordAudio[wordUrl];
					}
                    if (callback) callback();
                },
                Math.max((startTime - new Date() * 1), minTime)
            );
        }
    }

    @Onyx.handles("onanswerquestion")
    answerQuestion(answerNo){
        if(this.questionAnswered) return;
        this.questionAnswered = true;

        let correctWordIndex = this.getCorrectWordIndex();

		if(answerNo === correctWordIndex){
            if(!document.getElementById('word-' + answerNo)) return; // Occasionally with the word loading lag, we'll get overlapping timer events

            // Show them the correct word
            if(TYPE === "SPLIT"){
                document.getElementById('word-' + answerNo).classList.add("blink-green");

                this.modalResult(true, false);

                this.setTimeout(() => {
                    this.modalUnload();
                }, 2500);
            }else{
                document.getElementById("word-osr-blank").innerHTML = (this.currentQuestion.type == 'onset')?this.currentWords[answerNo].onset:this.currentWords[answerNo].rime;
                document.getElementById('word-osr').classList.add("blink-green");

                this.playWordAudio(this.currentWords[answerNo].text, this.currentWords[answerNo].audio, () =>{
                    document.getElementById('word-osr').classList.remove("blink-green");

                    // this.hideWords();
                    this.modalResult(true);
                }, 2500);
            }
        }else if(TYPE === "SPLIT"){
            // Show them incorrect word
            this.modalResult(false, false);

            document.getElementById('word-' + answerNo).classList.add("blink-red");
            this.playWordAudio(this.currentWords[answerNo].text, this.currentWords[answerNo].audio, () =>{
                this.modalUnload();
            }, 2500);
        }else{
            this.correctInARow = 0;

            //If onset or rime
			if((this.currentQuestion.type == 'onset' || this.currentQuestion.type == 'rime')){
                // Sight words

                // Offline mode
                if(centralStation.offline){
                    // Show them the incorrect word
                    // (incorrect)
                    document.getElementById("word-osr-blank").innerHTML = (this.currentQuestion.type == 'onset')?this.currentWords[answerNo].onset:this.currentWords[answerNo].rime;
                    document.getElementById('word-osr').classList.add("blink-red");
                    this.playWordAudio(this.currentWords[answerNo].text, this.currentWords[answerNo].audio, () =>{
                        document.getElementById('word-osr').classList.remove("blink-red");
                        
                        // (correct)
                        document.getElementById("word-osr-blank").innerHTML = (this.currentQuestion.type == 'onset')?this.currentWords[correctWordIndex].onset:this.currentWords[correctWordIndex].rime;
                        document.getElementById('word-osr').classList.add("blink-green");
                        this.playWordAudio(this.currentWords[correctWordIndex].text, this.currentWords[correctWordIndex].audio, () =>{
                            document.getElementById('word-osr').classList.remove("blink-green");

                            this.modalResult(false);
                        }, 2500);
                    }, 2500);
                }else{
                    if(this.currentQuestion.type == 'rime'){
                        // Show them the incorrect word
                        // (onset)
                        document.getElementById("word-osr-blank").innerHTML = this.currentWords[answerNo].rime;
                        document.getElementById('word-osr-onset').classList.add("blink-red");
                        this.playWordAudio(this.currentWords[answerNo].onset, this.currentWords[answerNo].onsetAudio, () =>{
                            document.getElementById('word-osr-onset').classList.remove("blink-red");
                            
                            // (rime)
                            document.getElementById('word-osr-blank').classList.add("blink-red");
                            this.playWordAudio(this.currentWords[answerNo].rime, this.currentWords[answerNo].rimeAudio, () =>{
                                document.getElementById('word-osr-blank').classList.remove("blink-red");

                                // (full)
                                document.getElementById('word-osr-blank').classList.add("blink-red");
                                document.getElementById('word-osr-onset').classList.add("blink-red");
                                this.playWordAudio(this.currentWords[answerNo].text, this.currentWords[answerNo].audio, () =>{
                                    document.getElementById('word-osr-blank').classList.remove("blink-red");
                                    document.getElementById('word-osr-onset').classList.remove("blink-red");

                                    // Now show them the correct word!
                                    // (onset)
                                    document.getElementById("word-osr-blank").innerHTML = this.currentWords[correctWordIndex].rime;
                                    document.getElementById('word-osr-onset').classList.add("blink-green");
                                    this.playWordAudio(this.currentWords[correctWordIndex].onset, this.currentWords[correctWordIndex].onsetAudio, () =>{
                                        document.getElementById('word-osr-onset').classList.remove("blink-green");
                                        
                                        // (rime)
                                        document.getElementById('word-osr-blank').classList.add("blink-green");
                                        this.playWordAudio(this.currentWords[correctWordIndex].rime, this.currentWords[correctWordIndex].rimeAudio, () =>{
                                            document.getElementById('word-osr-blank').classList.remove("blink-green");

                                            // (full)
                                            document.getElementById('word-osr-blank').classList.add("blink-green");
                                            document.getElementById('word-osr-onset').classList.add("blink-green");
                                            this.playWordAudio(this.currentWords[correctWordIndex].text, this.currentWords[correctWordIndex].audio, () =>{
                                                document.getElementById('word-osr-blank').classList.remove("blink-green");
                                                document.getElementById('word-osr-onset').classList.remove("blink-green");
                                                
                                                this.modalResult(false);
                                            }, 2250);
                                        }, 1000);
                                    }, 1000);
                                }, 2250);
                            }, 1000);
                        }, 1000);
                    }else{
                        // Show them the incorrect word
                        // (onset)
                        document.getElementById("word-osr-blank").innerHTML = this.currentWords[answerNo].onset;
                        document.getElementById('word-osr-blank').classList.add("blink-red");
                        this.playWordAudio(this.currentWords[answerNo].onset, this.currentWords[answerNo].onsetAudio, () =>{
                            document.getElementById('word-osr-blank').classList.remove("blink-red");
                            
                            // (rime)
                            document.getElementById('word-osr-rime').classList.add("blink-red");
                            this.playWordAudio(this.currentWords[answerNo].rime, this.currentWords[answerNo].rimeAudio, () =>{
                                document.getElementById('word-osr-rime').classList.remove("blink-red");
                                
                                // (full)
                                document.getElementById('word-osr-blank').classList.add("blink-red");
                                document.getElementById('word-osr-rime').classList.add("blink-red");
                                this.playWordAudio(this.currentWords[answerNo].text, this.currentWords[answerNo].audio, () =>{
                                    document.getElementById('word-osr-blank').classList.remove("blink-red");
                                    document.getElementById('word-osr-rime').classList.remove("blink-red");

                                    // Now show them the correct word!
                                    // (onset)
                                    document.getElementById("word-osr-blank").innerHTML = this.currentWords[correctWordIndex].onset;
                                    document.getElementById('word-osr-blank').classList.add("blink-green");
                                    this.playWordAudio(this.currentWords[correctWordIndex].onset, this.currentWords[correctWordIndex].onsetAudio, () =>{
                                        document.getElementById('word-osr-blank').classList.remove("blink-green");
                                        
                                        // (rime)
                                        document.getElementById('word-osr-rime').classList.add("blink-green");
                                        this.playWordAudio(this.currentWords[correctWordIndex].rime, this.currentWords[correctWordIndex].rimeAudio, () =>{
                                            document.getElementById('word-osr-rime').classList.remove("blink-green");
                                            
                                            // (full)
                                            document.getElementById('word-osr-blank').classList.add("blink-green");
                                            document.getElementById('word-osr-rime').classList.add("blink-green");
                                            this.playWordAudio(this.currentWords[correctWordIndex].text, this.currentWords[correctWordIndex].audio, () =>{
                                                document.getElementById('word-osr-blank').classList.remove("blink-green");
                                                document.getElementById('word-osr-rime').classList.remove("blink-green");
                                                
                                                this.modalResult(false);
                                            }, 2250);
                                        }, 1000);
                                    }, 1000);
                                }, 2250);
                            }, 1000);
                        }, 1000);
                    }
                    
                }
			}else{
				// Letter or sight words

				// Show them the incorrect word
				document.getElementById('word-s-' + answerNo).classList.add("blink-red");
				this.playWordAudio(this.currentWords[answerNo].text, this.currentWords[answerNo].audio, () =>{
					document.getElementById('word-s-' + answerNo).classList.remove("blink-red");

					// Now show them the correct word!
					document.getElementById('word-s-' + correctWordIndex).classList.add("blink-green");
					this.playWordAudio(this.currentWords[correctWordIndex].text, this.currentWords[correctWordIndex].audio, () =>{
						document.getElementById('word-s-' + correctWordIndex).classList.remove("blink-green");
						
						this.modalResult(false);
					}, 2500);
				}, 2500);
			}
        }
    }
}